import React from 'react';
import DuperbrowseStreamContextProvider from './DuperbrowseStreamContextProvider';
const DeviationDuperbrowseContext = ({ children, deviations, streamId, parent, preloadEnabled = true })=>{
    return /*#__PURE__*/ React.createElement(DuperbrowseStreamContextProvider, {
        stream: {
            items: deviations,
            streamId,
            parent,
            preloadEnabled
        }
    }, children);
};
DeviationDuperbrowseContext.displayName = 'DeviationDuperbrowseContext';
export default DeviationDuperbrowseContext;
